import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-067cec52")

_pushScopeId("data-v-067cec52")
const _hoisted_1 = { class: "report pt32" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title" }, "实训报告", -1)
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = { class: "action flex align-items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_a_table, {
          "row-key": "id",
          pagination: false,
          loading: _ctx.tableLoading,
          "data-source": _ctx.tableList,
          columns: _ctx.columns
        }, {
          status: _withId(({record}) => [
            _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getStatus(record.status)), 1)
          ]),
          action: _withId(({record}) => [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", {
                class: ["text-btn pointer mr8", {'disabled-txt': _ctx.stuStatus(record)}],
                onClick: ($event: any) => (!_ctx.stuStatus(record) && _ctx.gotoInfo(record))
              }, "查看", 10, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["loading", "data-source", "columns"])
      ]),
      _createVNode(_component_a_pagination, {
        class: "page",
        current: _ctx.pageNo,
        "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageNo = $event)),
        pageSize: _ctx.pageSize,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageSize = $event)),
        total: _ctx.total,
        showSizeChanger: "",
        "show-quick-jumper": "",
        onChange: _ctx.pageChange,
        onShowSizeChange: _ctx.showSizeChange
      }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
    ])
  ]))
})